routerConfig.$inject = [
  '$stateProvider'
];

export default function routerConfig($stateProvider) {
  $stateProvider

    .state({
      name: 'dashboard',
      parent: 'app',
      url: '/dashboard',
      abstract: true,
      views: {
        'header@app': {
          template: '<header></header>'
        },
        'sidenav@app': {
          template: '<sidenav></sidenav>'
        }
      },
      resolve: {
        isAuthenticated: ['authService', function(authService) {
          return authService.isAuthenticated();
        }]
      }
    })

    .state({
      name: 'home',
      parent: 'app',
      url: '',
      views: {
        'content@app': {
          template: '<home></home>'
        }
      },
      resolve: {
        isMobileOnly: ['authService', function(authService) {
          return authService.isMobileOnly();
        }]
      }
    })

    .state({
      name: 'profile',
      parent: 'dashboard',
      url: '/profile/user',
      views: {
        'content@app': {
          template: '<user-profile></user-profile>'
        }
      }
    })
    .state({
      name: 'profile.edit',
      url: '/edit',
      views: {
        'content@app': {
          template: '<edit-profile></edit-profile>'
        }
      }
    }).state({
      name: 'changepassword',
      parent: 'dashboard',
      url: '/changepassword',
      views: {
        'content@app': {
          template: '<change-password></change-password>'
        }
      }
    })

    .state({
      name: 'settings',
      parent: 'dashboard',
      url: '/settings',
      views: {
        'content@app': {
          template: '<settings></settings>'
        }
      }
    })

    .state({
      name: 'terms-conditions',
      parent: 'dashboard',
      url: '/terms-and-conditions',
      views: {
        'content@app': {
          template: '<terms-conditions></terms-conditions>'
        }
      }
    })

    .state({
      name: 'privacy',
      parent: 'dashboard',
      url: '/privacy',
      views: {
        'content@app': {
          template: '<privacy></privacy>'
        }
      }
    })
    .state({
      name: 'cards-management',
      parent: 'dashboard',
      url: '/cards-management/:status',
      views: {
        'content@app': {
          template: '<cards-management></cards-management>'
        }
      }
    })
    .state({
      name: 'rules-faq',
      parent: 'dashboard',
      url: '/rules-faq',
      views: {
        'content@app': {
          template: '<rules-faq></rules-faq>'
        }
      }
    })
    .state({
      name: 'faq-birds-critters',
      parent: 'rules-faq',
      url: '/birds-and-critters',
      views: {
        'content@app': {
          template: '<birds-critters></birds-critters>'
        }
      }
    })
    .state({
      name: 'faq-franchising',
      parent: 'rules-faq',
      url: '/franchising',
      views: {
        'content@app': {
          template: '<franchising></franchising>'
        }
      }
    })
    .state({
      name: 'faq-product-warranties',
      parent: 'rules-faq',
      url: '/product-warranties',
      views: {
        'content@app': {
          template: '<product-warranties></product-warranties>'
        }
      }
    })
    ;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/router.js